import { Grid } from '@mui/material';
import FeatureStatisticsGroup from 'src/modules/DashboardDefault/FeatureStatistics/FeatureStatisticsGroup';
import UsageCharts from 'src/modules/DashboardDefault/UsageCharts';
import { type CircleChartDataWrapper } from 'src/shared/types/charts';
import { type StatisticDataType } from '../../FeatureStatistics/types';

type OverviewColumnContentProps = {
  chartsData: CircleChartDataWrapper;
  statisticsData: {
    data: StatisticDataType[];
    gradient: string;
    title: string;
  };
  spacing: number;
};

export const OverviewColumnContent = ({ chartsData, statisticsData, spacing }: OverviewColumnContentProps) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      direction="column"
      spacing={spacing}
      sx={{ flex: 1, flexWrap: 'nowrap' }}
    >
      <UsageCharts chartData={chartsData} />
      <Grid item container>
        <FeatureStatisticsGroup data={statisticsData} />
      </Grid>
    </Grid>
  );
};
